import { render } from "./monthly.vue?vue&type=template&id=b733126a"
import script from "./monthly.vue?vue&type=script&lang=js"
export * from "./monthly.vue?vue&type=script&lang=js"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__